const debounce = require('lodash.debounce');

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    checkList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  mounted() {
  },
  methods: {
    // 提交
    submit: debounce(function () {
      const nodeList = this.$refs.areaTree.getCheckedNodes();
      if (!nodeList.length) {
        this.$errorMessage('请选择服务区域');
        return;
      }
      this.$emit('submit', this.getSubmitAreaList(nodeList));
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    // 获取提交的区域列表
    getSubmitAreaList(nodeList) {
      const list = [];
      nodeList.forEach((item1, index1) => {
        if (index1 === 0) {
          list.push(item1);
        }
        const flag = list.every(item2 => {
          return !item1.code.includes(item2.code);
        });
        if (flag) {
          list.push(item1);
        }
      });
      const areaList = [];
      const area = [];
      list.forEach(item => {
        areaList.push(item.code);
        area.push(item.name);
      });

      return {
        areaList,
        area: area.join('，')
      };
    },
    // 取消
    cancel() {
      this.$emit('cancel');
    }
  }
};
